import * as React from 'react';

import {Checkbox} from 'shells/checkbox/checkbox';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {useDidMountEffect} from 'shells/utils/hooks/use-did-mount-effect';

type Props = {
    onSave: (arg1: any) => void;
    setSavingToastKey: (arg1: string) => void;
    sendConfirmationReminder: boolean;
    sendUpcomingReminder: boolean;
    sendSoonReminder: boolean;
};

export function ReminderTiming(props: Props) {
    const {onSave, setSavingToastKey} = props;
    const [sendConfirmationReminder, setSendConfirmationReminder] = React.useState<boolean>(
        props.sendConfirmationReminder
    );
    const [sendUpcomingReminder, setSendUpcomingReminder] = React.useState<boolean>(
        props.sendUpcomingReminder
    );
    const [sendSoonReminder, setSendSoonReminder] = React.useState<boolean>(props.sendSoonReminder);

    const shouldDisableReminderEmails = NutClientConfig.isTrial;

    useDidMountEffect(() => {
        setSavingToastKey('reminders');
        onSave({sendConfirmationReminder, sendUpcomingReminder, sendSoonReminder});
    }, [sendConfirmationReminder, sendUpcomingReminder, sendSoonReminder]);

    return (
        <StackLegacy spacing={8}>
            <Checkbox
                label='When the meeting is booked'
                // @ts-expect-error
                type='checkbox'
                role='checkbox'
                checked={sendConfirmationReminder}
                aria-checked={sendConfirmationReminder}
                disabled={shouldDisableReminderEmails}
                onChange={(nowChecked: boolean) => {
                    setSendConfirmationReminder(nowChecked);
                }}
            />
            <Checkbox
                label='1 day before'
                // @ts-expect-error
                type='checkbox'
                role='checkbox'
                checked={sendUpcomingReminder}
                aria-checked={sendUpcomingReminder}
                disabled={shouldDisableReminderEmails}
                onChange={(nowChecked: boolean) => {
                    setSendUpcomingReminder(nowChecked);
                }}
            />
            <Checkbox
                label='30 minutes before'
                // @ts-expect-error
                type='checkbox'
                role='checkbox'
                checked={sendSoonReminder}
                aria-checked={sendSoonReminder}
                disabled={shouldDisableReminderEmails}
                onChange={(nowChecked: boolean) => {
                    setSendSoonReminder(nowChecked);
                }}
            />
            {shouldDisableReminderEmails ? (
                <i>Note: Reminder emails disabled during trial</i>
            ) : undefined}
        </StackLegacy>
    );
}
